
import { defineComponent, reactive, ref, onMounted, computed } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { ElMessageBox } from 'element-plus'
import formService from "@/core/services/FormService"
import { useStore } from "vuex";
import { useI18n } from "vue-i18n/index";
export default defineComponent({
    props: {
        idevent: {
            type: null,
            required: true,
            default: 0
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const formQRef = ref<FormInstance>()
        const rules = reactive<FormRules>({})
        const formQ = reactive({
            save: 0,
            sports: [],
            officers: [],
            mstatus: 0
        })
        const loading = ref(false)
        const listItems = ref<any>([])
        const Male = ref<number>(0)
        const Female = ref<number>(0)
        const otMen = ref<number>(0)
        const otWomen = ref<number>(0)
        const ofMen = ref<number>(0)
        const ofWomen = ref<number>(0)

        const getForm = async () => {
            loading.value = true;
            //resetForm(formQRef.value)
            formService.getForm(`${props.idevent}/2`, 'show')
                .then((res) => {
                    loading.value = false
                    Object.assign(formQ, res.data)
                    listItems.value = res.data
                    emit('formLoaded');
                }).catch(({ response }) => {
                    loading.value = false
                })
        }

        function calculateTotal(maleTotal: number | null, femaleTotal: number | null) {
            // Si maleTotal o femaleTotal son null, se asigna 0
            // Asegúrate de que male y female sean números
            const male = maleTotal !== null ? Number(maleTotal) : 0;
            const female = femaleTotal !== null ? Number(femaleTotal) : 0;

            // Realiza la suma de los valores numéricos
            return male + female;
        }

        const atleteTotal = () => {
            let _male = 0;
            let _female = 0;
            if(listItems.value?.sports){
                listItems.value?.sports.forEach((element) => {
                    element.events.forEach((sub) => {
                        _male += parseInt(sub.male)
                        _female += parseInt(sub.female)
                    })
                })
            }
            Male.value = _male
            Female.value = _female
            return _male + _female
        }

        // Cálculo de total para las columnas Masculino y Femenino oficiales
        const totalOT = () => {
            let _otMen = 0;
            let _otWomen = 0;
            if(listItems.value.sports){
                listItems.value?.sports.forEach((element) => {
                    _otMen += parseInt(element.otMen)
                    _otWomen += parseInt(element.otWomen)
                });
            }
            otMen.value = _otMen;
            otWomen.value = _otWomen;
            return _otMen + _otWomen;
        };

        const totalOFDelegation = () => {
            let _men = 0;
            let _women = 0;
            if(listItems.value?.officers){
                listItems.value?.officers.forEach((element)=>{
                    _men += parseInt(element.men)
                    _women += parseInt(element.women)
                })
            }
            ofMen.value = _men
            ofWomen.value = _women
            return _men + _women
        }

        function handleFocus(event: Event) {
            const input = event.target as HTMLInputElement;
            if (input.value === '0') {
                input.value = '';
            }
            totalOT()
            totalOFDelegation()
        }

        function handleBlur(event: Event, item: any, field: string, vmin:number, vmax:number) {
            const input = event.target as HTMLInputElement;
            if (input.value === '') {
                input.value = '0';
                item[field] = 0;
                //item.value.otMen = 0; // Asegurarse de actualizar el modelo si se deja vacío
            }

            const value = parseFloat(input.value);
            if(vmin>0 && vmax>0){
                if(value < vmin || value > vmax){
                    ElMessageBox.alert(`Número permitido debe ser entre ${vmin} y ${vmax}`, process.env.VUE_APP_NAME, {type: 'warning',})
                    item[field] = 0;
                    input.value = '0';
                }
                    
            } else if(vmax>0){
                if(value>vmax){
                    ElMessageBox.alert(`Número permitido no mayor a ${vmax}`, process.env.VUE_APP_NAME, {type: 'warning',})
                    item[field] = 0;
                    input.value = '0';
                }
            }


            totalOT()
            totalOFDelegation()
        }

        function handleBlurOf(event: Event, item: any, field: string, allowed:number, other: number) {
            const input = event.target as HTMLInputElement;
            if(allowed>0){
                const suma = parseInt(input.value) + other
                if(suma>allowed){
                    ElMessageBox.alert(`Número permitido no mayor a ${allowed}`, process.env.VUE_APP_NAME, {type: 'warning',})
                    item[field] = 0;
                    input.value = '0';
                }
            }

        }

        function handleInput(item: any, field: string, maxValue: number) {
            // Validar si maxValue es un número válido
            /*if (typeof maxValue !== 'number' || isNaN(maxValue) || maxValue === null) {
                console.error('El valor máximo proporcionado no es válido.');
                return;
            }
            */
            //const numericMaxValue = Number(maxValue);

            if (item[field] > maxValue) {
                ElMessageBox.alert(
                    'Número no permitido',
                    process.env.VUE_APP_NAME,
                    {type: 'warning',}
                )
                item[field] = 0;
            }
        }

        onMounted(() => {
            getForm()
        })

        return {
            t,
            loading,
            formQRef,
            rules,
            formQ,
            listItems,
            Male,
            Female,
            otMen,
            otWomen,
            ofMen,
            ofWomen,
            getForm,
            calculateTotal,
            handleBlur,
            handleBlurOf,
            handleFocus,
            totalOT,
            totalOFDelegation,
            atleteTotal,
            handleInput
        };
    },



})
